import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.ListItemFilters, {
        attrs: {
          icon: "ui-icon-calendar-none",
          title: _setup.t(_setup.title, _setup.options),
          subtitle: _setup.subtitle,
        },
        on: { click: _setup.openDialog },
      }),
      _vm._v(" "),
      _c(_setup.DateModal, {
        attrs: { value: _setup.isDialogOpened, "is-back": "" },
        on: { input: _setup.handleClosePlaceModal },
        scopedSlots: _vm._u([
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "pa-2 elevation-8" },
                  [
                    _c(
                      VBtn,
                      {
                        attrs: {
                          block: "",
                          depressed: "",
                          color: "primary",
                          disabled: !_setup.hasUnsavedDate,
                        },
                        on: { click: _setup.handleDateSelected },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_setup.t("Применить", _setup.options)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }